import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

const authHeaders = () => ({
  Authorization: `bearer ${localStorage.jwtToken}`,
  "Access-Control-Allow-Origin": "*",
});

export const getStationDeliveryHours = (stationId) => {
  return axios.get(`${aspNetUrl}StationDeliveryHours?StationId=${stationId}`, {
    headers: authHeaders(),
  });
};

export const StationDeliveryHoursPost = (data) => {
  return axios.post(`${aspNetUrl}StationDeliveryHours`, data, {
    headers: authHeaders(),
  });
};

export const getDateType = () => {
  return axios.get(`${aspNetUrl}date_type`, {
    headers: authHeaders(),
  });
};

export const dateTypePost = (data) => {
  return axios.post(`${aspNetUrl}date_type`, data, {
    headers: authHeaders(),
  });
};

export const getDateDayOfWeek = () => {
  return axios.get(`${aspNetUrl}date_day_of_week`, {
    headers: authHeaders(),
  });
};

export const dateDayOfWeekPost = (data) => {
  return axios.post(`${aspNetUrl}date_day_of_week`, data, {
    headers: authHeaders(),
  });
};

export const getSpecialDays = () => {
  return axios.get(`${aspNetUrl}date_sepcial`, {
    headers: authHeaders(),
  });
};

export const specialDaysPost = (data) => {
  return axios.post(`${aspNetUrl}date_sepcial`, data, {
    headers: authHeaders(),
  });
};
